import {MovieAlign, MovieLayerType} from 'common/src/modules/movie/movie.enums';
import {SourceLayerType} from 'common/src/modules/dynamicParameters/dynamicParameters.enums';
import {AnimationFunction} from './movieEditor.enums';
import {ComplexTextAlign} from 'common/src/modules/complexText/complexText.enums';

const movieEditorCustomThumbSize = 150;
const movieEditorDragTypeAsset = 'CL_ASSET';
const movieLayerTypeToSourceLayerTypeMap: Record<MovieLayerType, SourceLayerType> = {
  [MovieLayerType.Text]: SourceLayerType.Text,
  [MovieLayerType.Image]: SourceLayerType.Image,
  [MovieLayerType.Shape]: SourceLayerType.Shape,
  [MovieLayerType.Null]: SourceLayerType.Null,
  [MovieLayerType.Video]: SourceLayerType.Video,
  [MovieLayerType.PreComp]: SourceLayerType.Precomp,
};

const animationFunctions: Record<
  AnimationFunction,
  {i?: {x: number; y: number}; o?: {x: number; y: number}}
> = {
  [AnimationFunction.Linear]: {
    o: {x: 0.167, y: 0.167},
    i: {x: 0.833, y: 0.833},
  },
  [AnimationFunction.Ease]: {
    o: {x: 0.333, y: 0},
    i: {x: 0.667, y: 1},
  },
  [AnimationFunction.EaseIn]: {
    i: {x: 0.667, y: 1},
    o: {x: 0.167, y: 0.167},
  },
  [AnimationFunction.EaseOut]: {
    i: {x: 0.833, y: 0.833},
    o: {x: 0.333, y: 0},
  },
};

const complexTextToMovieAlign: Record<ComplexTextAlign, MovieAlign> = {
  [ComplexTextAlign.Left]: MovieAlign.Left,
  [ComplexTextAlign.Right]: MovieAlign.Right,
  [ComplexTextAlign.Center]: MovieAlign.Center,
  [ComplexTextAlign.Original]: MovieAlign.Left,
};

const movieLayerCategoryColors = [
  {name: 'Red', hex: '#FF6262'},
  {name: 'Pink', hex: '#FC80CA'},
  {name: 'Aqua', hex: '#9AF3F9'},
  {name: 'Lavender', hex: '#E09AF9'},
  {name: 'Peach', hex: '#F9AF9A'},
  {name: 'Blue', hex: '#95BDF2'},
  {name: 'Green', hex: '#94C77C'},
];

const defaultLayerCategoryColor = '#95BDF2';

export {
  movieLayerTypeToSourceLayerTypeMap,
  movieEditorCustomThumbSize,
  movieEditorDragTypeAsset,
  complexTextToMovieAlign,
  animationFunctions,
  movieLayerCategoryColors,
  defaultLayerCategoryColor,
};
